"use client";

import { createContext } from "react";

import type { AnalyticsEvent } from "../types/analyticsEvent.types";

export type AnalyticsContext = {
  logout: Function;
  track: (props: AnalyticsEvent) => Promise<void>;
  postEvent: (props: { event: string; body?: any }) => Promise<void>;
};

export const analyticsContext = createContext<AnalyticsContext>({
  logout: () => {},
  track: () => Promise.resolve(),
  postEvent: () => Promise.resolve(),
});
